import { http } from '@/api/httpAxios'
import createURLParams from '@/api/datasource/createURLParams'
import _ from 'lodash'

async function formatRequestData(data: any) {
  const formData = new FormData()

  if (data.imageFile) {
    formData.append('imageFile', data.imageFile)
  }

  if (data.detailsFile) {
    formData.append('detailsFile', data.detailsFile)
  }

  if (data.files) {
    data.files.forEach((file: any) => {
      formData.append('files', file)
    })
  }

  for (const key of Object.keys(data.fields ?? [])) {
    if (!_.isNil(data.fields[key])) {
      formData.append(
        key,
        _.isString(data.fields[key])
          ? data.fields[key]
          : JSON.stringify(data.fields[key])
      )
    }
  }
  return formData
}

export default class CttAPI {
  public static async createDocument(data: any) {
    return http.post(
      `/ctt/documents?type=${data.fields.type}`,
      await formatRequestData(data),
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  }

  public static async editDocument(id: number, data: any) {
    return http.put(
      `/ctt/documents/${id}?type=${data.fields.type}`,
      await formatRequestData(data),
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  }

  public static async deleteDocument(id: number) {
    return http.delete(`/ctt/documents/${id}`)
  }

  public static async getDocuments(
    type: any,
    limit: number,
    offset: number,
    sort: [] | null,
    filter: { [k: string]: any } | null
  ) {
    const filters = _.cloneDeep(filter)
    const params = createURLParams(limit, offset, sort, filters, false)
    params.append('type', type)

    return http.get(`/ctt/documents`, { params })
  }

  public static async getRidsWithoutTechRegions() {
    return http.get(`/ctt/documents-no-tech-regions`)
  }

  public static async createReference(data: any) {
    return http.post(`/ctt/references`, data)
  }

  public static async getReferences(type: string) {
    const params = new URLSearchParams([['type', type]])
    return http.get(`/ctt/references`, { params })
  }

  public static async getPhotos() {
    return http.get(`/ctt/references/photos`)
  }

  public static async addPhoto(photo: any, fields: any = {}) {
    return http.post(
      `/ctt/references/photos`,
      await formatRequestData({ imageFile: photo, fields }),
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  }

  public static async deletePhoto(id: number) {
    return http.delete(`/ctt/references/photos/${id}`)
  }

  public static async deleteReference(id: number) {
    return http.delete(`/ctt/references/${id}`)
  }

  public static async createNews(data: any) {
    return http.post('/ctt/news', await formatRequestData(data), {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  public static async editNews(data: any, id: number) {
    return http.put(`/ctt/news/${id}`, await formatRequestData(data), {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  public static async getNews(limit: number, offset: number) {
    const params = createURLParams(limit, offset)
    return http.get(`/ctt/news`, { params })
  }

  public static async deleteNews(id: number) {
    return http.delete(`/ctt/news/${id}`)
  }

  public static async updatePartnerUrl(imageFileId: number, url: string) {
    return http.put(`/ctt/references/partners/${imageFileId}/url`, { url })
  }

  public static async importDocumentFromUrl(url: string) {
    return http.get(`/ctt/import?url=${encodeURIComponent(url)}`)
  }
}
